<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
    height="100%"
  >
    <b-card class="fiat-memo-deposit">
      <validation-observer ref="memoDepositForm">
        <!-- 1. Description -->
        <b-alert
          v-if="headDescription"
          variant="info"
          show
          class="mb-1 p-2"
        >
          <div v-html="headDescription" />
        </b-alert>

        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <!-- Currency Select -->
            <b-form-group
              label-for="currency-select"
              :label="$t('fiat_wallet_deposit_currency')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('fiat_wallet_deposit_currency')"
                vid="Currency"
                rules="required"
              >
                <v-select
                  id="currency-select"
                  v-model="currency"
                  :options="currencyList"
                  :placeholder="$t('fiat_wallet_deposit_currency')"
                  label="name"
                  track-by="id"
                  @input="val => { currency = val; getBankList(val.id) }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <!-- Bank Select -->
            <b-form-group
              label-for="bank-select"
              :label="$t('bank')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('bank')"
                vid="Bank"
                rules="required"
              >
                <v-select
                  id="bank-select"
                  v-model="bankAccount"
                  :options="bankList"
                  :placeholder="$t('bank')"
                  label="bank_name"
                  track-by="id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 2. Memo -->
        <b-card
          v-if="bankAccount && bankAccount.memo"
          class="mb-0 memo-section mx-auto"
          style="max-width: 550px;"
        >
          <label><strong>{{ $t('your_deposit_memo') }}</strong></label>
          <b-input-group class="mt-1">
            <b-form-input
              ref="memoInput"
              :value="bankAccount.memo"
              readonly
              class="memo-value"
            />
            <b-input-group-append>
              <b-button
                ref="copyBtn"
                v-b-tooltip.hover.focus="copyTooltip"
                variant="outline-primary"
                :title="$t('copy')"
                style="height: 38px;"
                @click="copyMemo"
              >
                <BIconClipboard style="width: 14px;" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-card>

        <!-- 3. Bank Account Details -->
        <BankAccountDetails :bank-account="bankAccount" />
        <b-alert
          v-if="footerDescription"
          variant="info"
          show
          class="mb-1 p-2"
        >
          <div v-html="footerDescription" />
        </b-alert>

        <!-- 4. Deposit History -->
        <b-card class="deposit-history">
          <h3 class="mb-0">
            {{ $t('deposit_history') }}
          </h3>
          <br>
          <b-table
            :items="depositHistory"
            :fields="historyFields"
            small
            bordered
            responsive
          >
            <template #cell(amount)="data">
              <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.amount, 2)) }}</span>
            </template>
            <template #cell(automation.status)="data">
              <b-button
                size="sm"
                :variant=" data.item.automation.status === 'pending' ? 'warning' : data.item.automation.status === 'successful' ? 'success' :data.item.automation.status === 'rejected'? 'outline-info': 'danger'"
              >
                {{ data.item.automation.status }}
              </b-button>
            </template>
          </b-table>
        </b-card>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import fiatMemoDeposit from '@/modules/crypto/views/logic/customer-wallets/fiat/fiatMemoDeposit'

export default {

  mixins: [fiatMemoDeposit],
}
</script>

<style scoped>
.fiat-memo-deposit {
  margin: 0 auto;
}
.memo-value {
  font-size: 1.2em;
  color: #2d8cf0;
  font-weight: bold;
}
.bg-dark-blue {
  background-color: rgb(2, 58, 110);
}
</style>
